export const normalizeGallery = (gallery = [], fallbackUrl = "") => {
  const items = (Array.isArray(gallery) ? gallery : [])
    .map((item) => {
      if (typeof item === "string") {
        return { url: item.trim(), isMain: false };
      }

      return {
        url: String(item?.url || "").trim(),
        isMain: item?.isMain === true,
      };
    })
    .filter((item) => item.url);

  if (!items.length && fallbackUrl) {
    items.push({ url: String(fallbackUrl).trim(), isMain: true });
  }

  if (!items.length) {
    return [];
  }

  if (!items.some((item) => item.isMain)) {
    items[0].isMain = true;
  }

  let hasMain = false;
  return items.map((item) => {
    if (item.isMain && !hasMain) {
      hasMain = true;
      return { url: item.url, isMain: true };
    }

    return { url: item.url, isMain: false };
  });
};

export const getMainImageUrl = (card = {}) => {
  const gallery = normalizeGallery(card.gallery, card.imgUrl);
  const main = gallery.find((item) => item.isMain) || gallery[0];
  return main?.url || String(card.imgUrl || "").trim();
};

export const getGalleryPhotoUrls = (card = {}) => {
  const gallery = normalizeGallery(card.gallery, card.imgUrl);
  const main = gallery.find((item) => item.isMain);
  const others = gallery.filter((item) => item !== main);

  return [...(main ? [main] : []), ...others].map((item) => item.url);
};
